import { render, staticRenderFns } from "./ViewCard.vue?vue&type=template&id=391700bc"
import script from "./ViewCard.vue?vue&type=script&lang=js"
export * from "./ViewCard.vue?vue&type=script&lang=js"
import style0 from "./ViewCard.vue?vue&type=style&index=0&id=391700bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports